export default __webpack_public_path__ + "static/media/upcoming_30_plus_black.0bcf957c.svg";